import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import useToast from '@hooks/ui/useToast';
import {
    Dispatch, SetStateAction, useEffect, useState,
} from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    initialValue: string;
    id: string;
    name: string;
    setName: Dispatch<SetStateAction<string>>;
}

function UpdateNameBottomSheet({
    initialValue, name, setName, id,
}:Props) {
    const { t } = useTranslation('prepaidCard');
    const [inputName, setInputName] = useState<string>(initialValue);
    const { closeBottomSheet } = useBottomSheet();
    const toast = useToast();
    const updateName = () => {
        if (inputName.length === 0) {
            toast.error(t('manage.updateName.emptyError'));
            return;
        }
        UserPrepaidCardApi.updatePrepaidCardName(id, { name: inputName })
            .then(() => {
                closeBottomSheet();
                setName(inputName);
                toast.success(t('manage.updateName.success'));
            }).catch(() => {
                toast.error(t('manage.updateName.error'));
            });
    };
    useEffect(() => {
        setInputName(name);
    }, [name]);
    return (
        <Container fullWidth spacing={40} >
            <Column fullWidth spacing={12}>
                <Text color={colors.gray6} fontWeight='bold' size='lg'>
                    {t('manage.updateName.title')}
                </Text>
                <TextField placeholder={t('manage.updateName.placeholder')}
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)} />
            </Column>
            <Button fullWidth onClick={updateName}>{t('manage.updateName.save')}</Button>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 24px 20px 16px;
`;

export default UpdateNameBottomSheet;
